<template>
  <div>
    <div class="content">
      <common-header :data="['home', 'previewJoiningForm']" type="applicant"
        ><router-link
          v-if="!joiningDetails.finalsubmit"
          :class="{ disabled: !isEditable }"
          class="btn ml-2 btn-basic"
          :to="{
            name: 'editJoiningForm',
            params: {
              formVersionId,
              formMasterId,
            },
          }"
          v-b-tooltip.hover
          title="Edit Joining Form"
          ><i
            class="fa fa-pencil-square-o cst-color fa-2x"
            aria-hidden="true"
          ></i></router-link
        ><button
          v-if="!joiningDetails.finalsubmit"
          type="button"
          class="btn btn-cp ml-2"
          data-toggle="modal"
          data-target="#finalSubmitModal"
          :disabled="!isEditable"
        >
          Final Submit
        </button>

        <button
          v-else
          type="button"
          class="btn btn-cp ml-2 text-success font-weight-bold"
          v-b-tooltip.hover
          title="Request Edit Permission"
          data-toggle="modal"
          data-target="#finalSubmitModal"
          :disabled="!isEditable"
        >
          ✅ Final Submission Done
        </button></common-header
      >

      <!-- Final Submit / Request Edit Permission Modal -->
      <div class="modal fade" id="finalSubmitModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content m-t100">
            <div class="modal-header">
              <h3 class="modal-title">
                {{
                  joiningDetails.finalsubmit
                    ? "Request Edit Permission"
                    : "Final Submit"
                }}
              </h3>
              <button
                type="button"
                class="close"
                @click="closeModal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <h3 :style="'font-size:16px'">
                <template v-if="!joiningDetails.finalsubmit">
                  Once submitted, you won’t be able to make any changes.<br />
                  Are you sure you want to final submit your joining form?
                </template>
                <template v-else>
                  Your form has already been submitted. If you need to edit it
                  again, you can request permission by sending an email.<br />
                  Would you like to send a request now?
                </template>
              </h3>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-basic" @click="closeModal">
                Cancel
              </button>

              <button
                v-if="!joiningDetails.finalsubmit"
                type="button"
                class="btn btn-cp ml-2"
                @click="confirmFinalSubmit"
              >
                Confirm
              </button>

              <button
                v-else
                type="button"
                class="btn btn-cp ml-2"
                @click="sendEditPermissionRequest"
              >
                Send Request
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <h4><strong>Personal Details</strong></h4>
        <div class="col-sm-12 col-12 pr-sm-2 mb-3">
          <div class="my-2 text-center">
            <img
              v-if="joiningProfilePic !== null"
              :src="joiningProfilePic"
              alt="Profile Picture"
              class="mx-auto d-block rounded-circle"
              style="width: 200px; height: 200px; object-fit: cover"
            />
          </div>
        </div>
        <div class="well">
          <table
            class="table table-condensed table-compressed"
            aria-label="Personal Details"
            aria-hidden="true"
          >
            <tbody>
              <tr v-for="(questionPair, index) in questions" :key="index">
                <td class="col-md-3 px-2">
                  <strong>{{ formatLabel(questionPair[0].label) }}</strong>
                </td>
                <td class="col-md-3 px-2">
                  {{ flatData[questionPair[0].key]?.value || "-" }}
                </td>
                <td v-if="questionPair[1]" class="col-md-3 px-2">
                  <strong>{{ formatLabel(questionPair[1].label) }}</strong>
                </td>
                <td v-if="questionPair[1]" class="col-md-3 px-2">
                  {{ flatData[questionPair[1].key]?.value || "-" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-12">
        <h4><strong>Uploaded Documents</strong></h4>

        <div class="documents-container">
          <div
            v-for="(doc, index) in documents"
            :key="index"
            class="document-card"
          >
            <document-preview
              :title="formatDocumentName(doc.label)"
              :id="doc.value"
              :documentUrl="doc.value"
              :isApplicant="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentPreview from "./download-uploaded-document.vue";
import applicantAxios from "../_utils/axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isEditMode: false,
      joiningProfilePic: null,
      data: null,
      questions: [],
    };
  },
  props: {
    formMasterId: {
      type: [String, Number],
      required: false,
    },
    formVersionId: {
      type: [String, Number],
      required: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    DocumentPreview,
  },
  watch: {
    joiningDetails: {
      async handler(newVal) {
        this.data = newVal.joiningDetails.response;
        await this.$store.dispatch(
          "$_form_template/fetchEditorFormVersion",
          newVal.joiningDetails.formVersionId
        );
        this.fetchProfilePic();
      },
      immediate: true,
    },
    version: {
      handler(newVal) {
        const allQuestions = [];
        for (const section of newVal.form_json.sections) {
          for (const question of section.body) {
            if (question.type != "file") allQuestions.push(question);
          }
        }
        const pairedQuestions = [];
        for (let i = 0; i < allQuestions.length; i += 2) {
          pairedQuestions.push([allQuestions[i]]);
          if (allQuestions[i + 1])
            pairedQuestions[pairedQuestions.length - 1].push(
              allQuestions[i + 1]
            );
        }
        this.questions = pairedQuestions;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      joiningDetails: "$_applicant_master/getJoiningDetails",
      version: "$_form_template/getEditorActiveFormVersion",
    }),
    flatData() {
      const result = {};
      for (const sectionId in this.data) {
        const section = this.data[sectionId];
        for (const questionId in section) {
          result[questionId] = section[questionId];
        }
      }
      return result;
    },
    documents() {
      const result = {};
      for (const sectionId in this.data) {
        const section = this.data[sectionId];
        for (const questionId in section) {
          result[questionId] = section[questionId];
        }
      }
      const allFiles = Object.values(result)
        .filter((item) => item.type == "file" && item.value)
        .map((item) => ({
          label: item.label,
          value: item.value,
          name: item.name,
        }));
      return allFiles;
    },
  },
  methods: {
    formatLabel(label) {
      if (!label) return "";

      // Replace underscores with spaces
      let formatted = label.replace(/_/g, " ");

      // Insert space before capital letters (for camelCase)
      formatted = formatted.replace(/([a-z])([A-Z])/g, "$1 $2");

      // Capitalize the first letter of each word
      formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());

      return formatted;
    },
    formatDocumentName(name) {
      if (!name || typeof name !== "string") return "";
      return name
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Add a space before capital letters
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
    },
    editJoiningForm() {
      this.$router.push({
        name: "editJoiningForm",
      });
    },
    async fetchProfilePic() {
      try {
        const fileId = this.documents?.find(
          (doc) => doc.label === "Passport Photo"
        )?.value;
        if (fileId) {
          const url = `/applicant-master/joining/documents/view/passportPhoto?FileId=${fileId}`;
          const response = await applicantAxios.get(url, {
            responseType: "blob",
          });

          const blobUrl = window.URL.createObjectURL(response.data);

          // Store the Blob URL in the component state
          this.joiningProfilePic = blobUrl;
        }
      } catch (error) {
        console.error("Error fetching the profile picture:", error);
      }
    },
    closeModal() {
      $("#finalSubmitModal").modal("hide");
    },
    confirmFinalSubmit() {
      this.$store.dispatch("$_applicant_master/finalSubmit");
      this.closeModal();
    },
    sendEditPermissionRequest() {
      this.$store.dispatch("$_applicant_master/sendEditPermissionRequest");
      this.closeModal();
    },
  },
  mounted() {
    this.fetchProfilePic();
  },
};
</script>
<style scoped>
.documents-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 10px;
}

.document-card {
  flex: 1 1 calc(25% - 16px);
  max-width: calc(25% - 16px);
  box-sizing: border-box;
}

/* Large screens (1024px to 1199px) */
@media (max-width: 1199px) {
  .document-card {
    flex: 1 1 calc(33.33% - 16px); /* 3 cards per row */
    max-width: calc(33.33% - 16px);
  }
}

/* Medium screens (768px to 1023px) */
@media (max-width: 1023px) {
  .document-card {
    flex: 1 1 calc(50% - 16px); /* 2 cards per row */
    max-width: calc(50% - 16px);
  }
}

/* Small screens (481px to 767px) */
@media (max-width: 767px) {
  .document-card {
    flex: 1 1 100%; /* 1 card per row */
    max-width: 100%;
  }
}

/* Mobile screens (480px and below) */
@media (max-width: 480px) {
  .document-card {
    flex: 1 1 100%; /* 1 card per row */
    max-width: 100%;
  }
}
</style>
